import React, { Fragment, useCallback, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { fetchAppliedJobsRequest } from "../../../redux/jobseeker/applied_jobs/actions";
import { showToast } from "../../Common/Toast";
import {
  capitalize,
  formatDate,
  formatExperienceOutput,
  generateSlug,
  unslugAndCapitalize,
} from "../../Common/CommonFunction";
import styled from "styled-components";
import { Badge, Col, Card, CardHeader, CardBody } from "reactstrap";
import { Edit2, Trash2, Eye, Copy } from "react-feather";
import { Link } from "react-router-dom";
import NoDataFound from "../../Common/NoDataFound";
import Spinner from "../../Common/Spinner";
import { customStyles } from "../../../Constant";
import { addDays, startOfYear, endOfToday } from "date-fns";
const CustomHeader = ({ cell }) => (
  <th style={{ fontWeight: "bold" }}>{cell.label}</th>
);

const AppliedJobDataTable = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [formData, setFormData] = useState({
    dateRange: {
      key: "selection",
      startDate: startOfYear(new Date()), // Start of current year
      endDate: endOfToday(), // Today
      type: "ALL",
    },
  });


  const getStatusColor = (status) => {
    // Implement your logic to determine the badge color based on status
    // For example:
    switch (status) {
      case "HIRED":
        return "badge-light-success";
      case "SHORTLISTED":
        return "badge-light-success";
      case "INTERVIEWED":
        return "badge-light-primary";
      case "PENDING":
        return "badge-light-info";
      case "VIEWED":
        return "badge-light-warning";

      case "REJECTED":
        return "badge-light-danger";
      default:
        return "badge-light-primary";
    }
  };

  // const tableColumns = [
  //   {
  //     name: "#",
  //     short_column: "job_id",
  //     cell: (row, index) => (currentPage - 1) * perPage + index + 1,
  //     width: "5%",
  //     sortable: true,
  //     center: false,
  //   },
  //   {
  //     name: "Job Title",
  //     short_column: "job_name",
  //     cell: (row) =>
  //       row.job_name ? (
  //         <Link
  //           to={`${process.env.PUBLIC_URL}/jobseeker/job_details/${generateSlug(
  //             row.job_name,
  //             row.job_location,
  //             formatExperienceOutput(
  //               row.work_experience_min,
  //               row.work_experience_max
  //             ).replace("-", "-to-"),
  //             row.job_id
  //           )}`}
  //           title={"View Job"}
  //         >
  //           {capitalize(row.job_name)}
  //         </Link>
  //       ) : (
  //         "-"
  //       ),
  //     sortable: true,
  //     center: false,
  //   },
  //   {
  //     short_column: "company_name",
  //     name: "Company Name",
  //     cell: (row) => (row.company_name ? capitalize(row.company_name) : "_"),
  //     sortable: true,
  //     center: false,
  //   },

  //   {
  //     name: "Experience",

  //     cell: (row) => {
  //       const experienceOutput = formatExperienceOutput(
  //         row.work_experience_min,
  //         row.work_experience_max
  //       );
  //       return experienceOutput !== "N/A" ? experienceOutput : "-";
  //     },

  //     sortable: false,
  //     center: true,
  //   },
  //   {
  //     name: "Location",
  //     short_column: "job_location",
  //     cell: (row) => (row.job_location ? capitalize(row.job_location) : "_"),
  //     sortable: true,
  //     center: false,
  //   },
  //   {
  //     name: "Applied On",
  //     short_column: "created_at",
  //     cell: (row) => (row.created_at ? formatDate(row.created_at) : "_"),
  //     sortable: true,
  //     center: false,
  //   },
  //   // {
  //   //   name: "Status",

  //   //   sortable: false,
  //   //   center: false,
  //   //   cell: (row) => (
  //   //     <span
  //   //       className={`badge ${getCandidateStatusColor(row.candidate_status)}`}
  //   //     >
  //   //       {unslugAndCapitalize(row.candidate_status)}
  //   //     </span>
  //   //   ),
  //   // },
  //   {
  //     name: "Actions",

  //     cell: (row) => (
  //       <div>
  //         <span>
  //           <Link
  //             to={`${process.env.PUBLIC_URL
  //               }/jobseeker/job_details/${generateSlug(
  //                 row.job_name,
  //                 row.job_location,
  //                 formatExperienceOutput(
  //                   row.work_experience_min,
  //                   row.work_experience_max
  //                 ).replace("-", "-to-"),
  //                 row.job_id
  //               )}`}
  //             title="View Job"
  //           >
  //             <Eye
  //               size={18}
  //               className="eye-icon"
  //               style={{ marginRight: "10px" }}
  //             />
  //           </Link>
  //           {/* <Edit2 size={18} color="blue" style={{ marginRight: "10px" }} />
  //             <Copy size={18} color="orange" /> */}
  //         </span>
  //       </div>
  //     ),
  //     sortable: false,
  //     center: true,
  //   },
  // ];



  const tableColumns = [
    {
      name: "#",
      short_column: "job_id",
      cell: (row, index) => (currentPage - 1) * perPage + index + 1,
      width: "60px", // Use a fixed, small width for the index column for consistency
      sortable: false,
    },
    {
      name: "Job Title",
      short_column: "job_name",
      sortable: false,
      grow: 3, // Allow this primary column the most space to grow
      minWidth: '180px', // Ensure the title doesn't get overly squished
      cell: (row) =>
        row.job_name ? (
          // Wrapper div is crucial for reliable text-overflow ellipsis
          <div
            style={{
              width: '100%',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            title={capitalize(row.job_name)} // The tooltip shows the full title on hover
          >
            <Link
              to={`${process.env.PUBLIC_URL}/jobseeker/job_details/${generateSlug(
                row.job_name,
                row.job_location,
                formatExperienceOutput(
                  row.work_experience_min,
                  row.work_experience_max
                ).replace("-", "-to-"),
                row.job_id
              )}`}
              title={"View Job"}
            >
              {capitalize(row.job_name)}
            </Link>
          </div>
        ) : (
          "-"
        ),
    },
    {
      name: "Company Name",
      short_column: "company_name",
      sortable: false,
      grow: 2, // Give company name significant space
      minWidth: '150px',
      cell: (row) =>
        row.company_name ? (
          <div
            style={{
              width: '100%',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            title={capitalize(row.company_name)}
          >
            {capitalize(row.company_name)}
          </div>
        ) : (
          "-"
        ),
    },
    {
      name: "Experience",
      sortable: false,
      center: true,
      grow: 1.5,
      minWidth: '120px',
      cell: (row) => {
        const experienceOutput = formatExperienceOutput(
          row.work_experience_min,
          row.work_experience_max
        );
        return experienceOutput !== "N/A" ? experienceOutput : "-";
      },
    },
    {
      name: "Location",
      short_column: "job_location",
      sortable: false,
      grow: 2,
      minWidth: '140px',
      cell: (row) => (row.job_location ? capitalize(row.job_location) : "-"),
    },
    {
      name: "Applied On",
      short_column: "created_at",
      sortable: false,
      grow: 1.5,
      minWidth: '120px',
      cell: (row) => (row.created_at ? formatDate(row.created_at) : "-"),
    },
    // {
    //   name: "Status",
    //   sortable: false,
    //   center: true, // Badges look better centered
    //   grow: 1,
    //   minWidth: '120px',
    //   cell: (row) => (
    //     <span
    //       className={`badge ${getCandidateStatusColor(row.candidate_status)}`}
    //     >
    //       {unslugAndCapitalize(row.candidate_status)}
    //     </span>
    //   ),
    // },
    {
      name: "Actions",
      sortable: false,
      center: true,
      width: '80px', // A fixed width is best for a single-icon action column
      cell: (row) => (
        <div>
          <Link
            to={`${process.env.PUBLIC_URL
              }/jobseeker/job_details/${generateSlug(
                row.job_name,
                row.job_location,
                formatExperienceOutput(
                  row.work_experience_min,
                  row.work_experience_max
                ).replace("-", "-to-"),
                row.job_id
              )}`}
            title="View Job"
          >
            <Eye
              size={18}
              className="eye-icon"
            />
          </Link>
        </div>
      ),
    },
  ];

  useEffect(() => {
    const data = {
      status: "ALL",
      type: "ALL",

      startDate: null,
      endDate: null,
      keyword: "",
    };
    dispatch(fetchAppliedJobsRequest(1, 10, data));
  }, [dispatch]);

  const appliedJobsReducerData = useSelector(
    (state) => state.appliedJobsReducer
  );
  const appliedJobsData = appliedJobsReducerData.data.data;

  if (appliedJobsReducerData.error) {
    showToast("error", appliedJobsReducerData.error);
  }

  const handleSort = async (column, direction) => {
    console.log("column", column);

    try {
      const page = currentPage;
      const per_page = perPage;
      const short_by = column.short_column;
      const column_direction = direction;
      const data = {
        status: "ALL",
        type: formData.dateRange.type,

        startDate: formData.dateRange.startDate
          ? formData.dateRange.startDate.toISOString()
          : null, // Convert Date objects to strings
        endDate: formData.dateRange.endDate
          ? formData.dateRange.endDate.toISOString()
          : null,
        keyword: searchQuery,
      };
      dispatch(
        fetchAppliedJobsRequest(
          page,
          per_page,
          data,
          short_by,
          column_direction
        )
      );
    } catch (error) {
      console.error("Error fetching sorted data:", error);
    }
  };

  return (
    <Fragment>
      <Card>
        <CardHeader className="card-no-border ">
          <div className="header-top">
            <h5>Applied Jobs</h5>
            {appliedJobsData && (
              <div className="card-header-right-icon">
                <Link to={`${process.env.PUBLIC_URL}/jobseeker/applied_Jobs`}>
                  View All
                </Link>
              </div>
            )}
          </div>
        </CardHeader>
        <CardBody className="px-0 py-3 pt-0">
          <div className="table-container">
            <DataTable
              responsive
              customStyles={customStyles}
              data={appliedJobsData}
              columns={tableColumns}
              keyField="id"
              striped={true}
              center={true}
              headerComponent={CustomHeader}
              progressPending={appliedJobsReducerData.isLoading}
              progressComponent={<Spinner />}
              noDataComponent={<NoDataFound message={"No Applied Job Found"} />}
              onSort={(column, direction) => handleSort(column, direction)}
            /></div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default AppliedJobDataTable;
